import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { CloseIcon } from 'components/SvgIcon';
import RenderPageElements from 'pages/admin/common/page-elements/RenderPageElements';
import TabList from 'components/TabList';
import RenderHTMLMail from 'pages/admin/common/page-elements/RenderHTMLMail';

const CommonSessionDetailPreviewModal = ({ visible, onClose, info = {}, details = [] }) => {
    const { t } = useTranslation();

    const tabList = [
        {
            key: 'page',
            title: t('Page'),
            container: (
                <>
                    <div className="render-page-container">
                        <RenderPageElements info={info} details={details} />
                    </div>
                </>
            ),
        },
        {
            key: 'news',
            title: t('News'),
            container: (
                <>
                    <div className="render-page-container html-mail_wrapper">
                        <RenderHTMLMail info={info} details={details} />
                    </div>
                </>
            ),
        },
    ];

    return (
        <Modal
            title={t('Preview')}
            visible={visible}
            width={823}
            footer={null}
            closeIcon={<CloseIcon />}
            onCancel={() => onClose()}
        >
            <TabList tabs={tabList} animated={false} defaultActiveKey="page" />
        </Modal>
    );
};

export default CommonSessionDetailPreviewModal;

CommonSessionDetailPreviewModal.propTypes = {
    info: PropTypes.object,
    byId: PropTypes.object,
    order: PropTypes.array,
};
